module.exports = __webpack_public_path__ + "static/media/logo-design.a3061807.jpg";